var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calc-desenquadramento-mei-results"},[_c('h2',[_vm._v("Calculadora desenquadramento MEI")]),_c('p',{staticClass:"calc-desenquadramento-mei-results__subtitle"},[_vm._v("Ocorreu um erro tente novamente mais tarde")])])
}]

export { render, staticRenderFns }